import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const logoSrc = "/logo.png";

export default function LandingNav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#080808]/95 backdrop-blur-md border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1200px] mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2.5 cursor-pointer no-underline">
          <img src={logoSrc} alt="ScienceOne" className="h-7 w-7 rounded-full object-cover shrink-0" />
          <span className="font-bold text-white text-lg tracking-tight">ScienceOne</span>
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          <a href="#features" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer no-underline whitespace-nowrap">功能</a>
          <a href="#cases" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer no-underline whitespace-nowrap">案例</a>
          <a href="#pricing" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer no-underline whitespace-nowrap">定价</a>
          <a href="#" className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer no-underline whitespace-nowrap">开放平台</a>
          <a href="#" className="text-sm text-white/40 hover:text-white/60 transition-colors cursor-pointer no-underline whitespace-nowrap">中 / EN</a>
          <Link to="/" className="text-sm font-medium bg-[#3d69e8] hover:bg-[#3060d0] text-white px-4 py-2 rounded-lg transition-colors cursor-pointer no-underline whitespace-nowrap">
            开始体验
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-white/60 hover:text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0f0f0f] border-t border-white/5 px-6 py-4 flex flex-col gap-4">
          <a href="#features" className="text-sm text-white/70 hover:text-white cursor-pointer" onClick={() => setMenuOpen(false)}>功能</a>
          <a href="#cases" className="text-sm text-white/70 hover:text-white cursor-pointer" onClick={() => setMenuOpen(false)}>案例</a>
          <a href="#pricing" className="text-sm text-white/70 hover:text-white cursor-pointer" onClick={() => setMenuOpen(false)}>定价</a>
          <a href="#" className="text-sm text-white/70 hover:text-white cursor-pointer">开放平台</a>
          <Link to="/" className="text-sm font-medium bg-[#3d69e8] text-white px-4 py-2.5 rounded-lg text-center" onClick={() => setMenuOpen(false)}>
            开始体验
          </Link>
        </div>
      )}
    </nav>
  );
}
